export default __webpack_public_path__ + "static/stats_2-ec56da440685cbc4909eed78a82ecd6b.png";